module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('home-svg'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip"
  }, [_c('div', {
    staticClass: "tooltip-content"
  }, [_vm._v("λεκάνη")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc3f2be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 566
// module chunks = 1